import { YES_OR_NO_OPTIONS } from '~services/constant/common';
import HelperOptions from '~component/helper/helper-options';

// function getOptions(carrier, options, h) {

//   console.log(options);

//   if (carrier === 'radio') {
//     return options.map(item => (
//       <el-radio
//         key={ item.value }
//         label={ item.value }
//       >
//         { item.label }
//       </el-radio>
//     ));
//   }

//   if (carrier === 'checkbox') {
//     return options.map(item => (
//       <el-checkbox
//         key={ item.value }
//         label={ item.value }
//       >
//         { item.label }
//       </el-checkbox>
//     ));
//   }

//   if (carrier === 'radioButton') {
//     return options.map(item => (
//       <el-radio-button
//         key={ item.value }
//         label={ item.value }
//       >
//         { item.label }
//       </el-radio-button>
//     ));
//   }

//   return options.map(item => (
//     <el-option
//       { ...data }
//       key={ item.value }
//       value={ item.value }
//       label={ item.label }
//     />
//   ));
// }

// 是或否
export default {
  functional: true,
  render(createElement, context) {
    // return getOptions(context.props.carrier, YES_OR_NO_OPTIONS, createElement);
    return (
      <HelperOptions
        { ...context.data }
        options={ YES_OR_NO_OPTIONS }
      />
    );
  },
};
